import { StatusCheckService } from './../../../../../../libs/share/src/lib/status-check.service';
import { ResponseStructure } from './../../../../../../libs/share/src/lib/_models/shared-models';
import { Component, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { CourseResponseDTO } from '../../_models/course';
import { Router, ActivatedRoute } from '@angular/router';
import { CourseService } from '../../_services/course.service';
import { GlobalService } from '../../_services/global.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'iq-central-front-end-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss'],
})
export class CoursesComponent implements OnInit {
  sub: Subscription = new Subscription();
  courses: CourseResponseDTO[] = [];
  filteredCourses: any;
  savedCourses: any[] = [];
  fetchCoursesFailed: boolean;
  isFetchingCourses: boolean = false;
  constructor(
    private router: Router,
    private _course: CourseService,
    private _global: GlobalService,
    private status: StatusCheckService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getCourses();
    console.log(this.isOnline$, this.fetchCoursesFailed);
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  transformDuration(index): string {
    const duration = this.courses[index].duration;
    const transformedDuration = duration.split(':');
    return transformedDuration[0] + 'Hrs:' + transformedDuration[1] + 'Mins';
  }

  getCourses() {
    this.isFetchingCourses = true;

    this.sub.add(
      this._course
        .getAllCompanyCourses()
        .pipe(finalize(() => (this.isFetchingCourses = false)))
        .subscribe((res) => {
          res
            ? (this.fetchCoursesFailed = false)
            : (this.fetchCoursesFailed = true);

          this.courses = this.filteredCourses = res['responseResult'];
        })
    );
  }

  filter(query: string) {
    this.courses = query
      ? this.filteredCourses.filter((c) =>
          c.title.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredCourses;
  }

  get isOnline$(): Observable<boolean> {
    return this.status.online$;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  sortByDate() {
    this.courses.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }
  sortByName() {
    this.courses.sort((a, b) => {
      if (a.title < b.title) return -1;
      else if (a.title > b.title) return 1;
      else return 0;
    });
  }

  sortBy() {}
  rating(course) {
    var total = 0;
    for (var i in course.courseRatings) {
      total += course.courseRatings[i].rating;
    }
    const rating = total / course.courseRatings.length;
    if (rating >= 1 && rating < 2) {
      return 'one';
    } else if (rating >= 2 && rating < 3) {
      return 'two';
    } else if (rating >= 3 && rating < 4) {
      return 'three';
    } else if (rating >= 4 && rating < 5) {
      return 'four';
    } else if (rating >= 5) {
      return 'five';
    }
  }

  selectDeselectCourses(event, data) {
    console.log(event.target.nextSibling.firstChild);
    if (event.target.nextSibling.firstChild.classList.contains('dislike')) {
      event.target.nextSibling.firstChild.classList.remove('dislike');
      event.target.nextSibling.firstChild.classList.add('like');
    } else {
      event.target.nextSibling.firstChild.classList.add('dislike');
      event.target.nextSibling.firstChild.classList.remove('like');
    }

    this.savedCourses.includes(data)
      ? (this.savedCourses = this.savedCourses.filter((s) => s !== data))
      : this.savedCourses.push(data);

    console.log(this.savedCourses);

    const payload = this.savedCourses;

    this.sub.add(
      this._course.toggleSavedCourse(data.code, payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }
}
